import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

require('./service-type-indication.scss');
@Component({
  standalone: false,
  selector: 'app-service-type-indication',
  templateUrl: './service-type-indication.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceTypeIndicationComponent {

  @Input() serviceType: string;
  @Input() isShort: boolean;

}
